module.exports = __webpack_public_path__ + "static/media/sync-alt.cf301954.svg";